module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categoryManager"
  }, [_vm._l((_vm.categories), function(categoryl1) {
    return _c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(categoryl1.name + '(' + categoryl1.goods_cnt + '个商品)')
      }
    }), _vm._v(" "), (categoryl1.goods_cnt == 0 && categoryl1.items.length == 0) ? _c('i', {
      staticClass: "fa fa-trash pull-right",
      on: {
        "click": function($event) {
          _vm.deleteCategoryL1(categoryl1.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-edit pull-right",
      on: {
        "click": function($event) {
          _vm.goCategoryL1Edit(categoryl1.id)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus pull-right",
      on: {
        "click": function($event) {
          _vm.goCategoryL2Create(categoryl1.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((categoryl1.items), function(categoryl2) {
      return _c('div', {
        staticClass: "col-sm-4 col-md-2"
      }, [_c('div', {
        staticClass: "thumbnail",
        on: {
          "click": function($event) {
            _vm.goCategoryL2Detail(categoryl2.id)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": categoryl2.icon,
          "alt": "..."
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "caption",
        domProps: {
          "textContent": _vm._s(categoryl2.text + '(' + categoryl2.goods_cnt + ')')
        }
      }), _vm._v(" "), (categoryl2.goods_cnt == 0) ? _c('img', {
        staticClass: "deleteBtn",
        attrs: {
          "src": "https://ogmcsrgk5.qnssl.com/vcdn/21841/小程序图标/删除.png"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.deleteCategoryL2(categoryl2.id)
          }
        }
      }) : _vm._e()])])
    }))])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goCategoryL1Create
    }
  }, [_vm._v("添加新的一级分类")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd7964b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CategoryManager.vue
// module id = 387
// module chunks = 1